import { render, staticRenderFns } from "./SuggestionStatus.vue?vue&type=template&id=e104136a"
import script from "./SuggestionStatus.vue?vue&type=script&lang=js"
export * from "./SuggestionStatus.vue?vue&type=script&lang=js"
import style0 from "./SuggestionStatus.vue?vue&type=style&index=0&id=e104136a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports